import script from "./LegoSetCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./LegoSetCard.vue?vue&type=script&setup=true&lang=ts"

import "./LegoSetCard.vue?vue&type=style&index=0&id=154b21c1&lang=css"

export default script